import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replaceReminderInListCaches } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	patchRemindersIdV2,
	type UpdateReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { formatApiDate } from "web_myplann/Shared/Utils/apiDate";

type SnoozeReminderVariables = { id: string; snoozedUntil: Date };

export const useReminderSnoozeMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdateReminderResponseDTO, Error, SnoozeReminderVariables>(
		{
			mutationFn: processResponse(
				({ id, snoozedUntil }: SnoozeReminderVariables) =>
					patchRemindersIdV2(
						{ snoozedUntil: formatApiDate(snoozedUntil) },
						Number(id),
					),
			),
			onSuccess: (data) => {
				replaceReminderInListCaches(queryClient, data);
			},
		},
	);
};
